import { atom } from 'recoil';

export const scrollMemoryAtom = atom({
  key: 'scrollMemoryAtom',
  default: {},
});
